import { Vue, Component } from "vue-property-decorator";
import { State } from 'vuex-class';

@Component
export default class CLComponentVue extends Vue {
    @State('en')
    public langEnglish!: boolean;

    // errorTranslation(error)
    public errorTranslation(error: string) {
        if (!this.langEnglish) {
            return error;
        }

        switch (error) {
            case "お手数ですがログインし直してください。":
                return "Please then try again."
            case "メールアドレスを正しく入力してください。":
                return "Please enter your e-mail address correctly."
            case "メールアドレスの入力に複数回誤りがありました。お手数ですがお問い合わせよりサポートへご連絡ください。":
                return "Please wait a while and then try again."
            case "メールアドレスの入力に複数回誤りがありました。しばらく経ってから再度お試してください。":
                return "Please wait a while and then try again."
            case "しばらく待ってから再度実行してください。お手数ですがお問い合わせよりサポートへご連絡ください。":
                return "Please wait a while and then try again."
            case "正しい認証コードを入力してください。":
                return "Authentication code is incorrect."
            case "メールアドレス・パスワードが違います":
                return "E-mail address is wrong, or password is wrong."
            case "利用規約・個人情報保護方針に同意してください。":
                return "Please agree with the Terms of Service and Privacy Policy."
            case "パスワードが一致しません。":
                return "Passwords do not match"
            default:
                ;
        }

        //複数返す場合
        error = error.replace("メールアドレスを正しく入力してください。", "Please enter name within  200 characters.")
        error = error.replace("お名前が未入力です。", "Please enter name within  200 characters.")
        error = error.replace("お名前が未入力です。", "Please enter your name.")
        error = error.replace("お名前を200文字以下で入力してください。", "Please enter name within  200 characters.")
        error = error.replace("メールアドレスが未入力です。", "Email address has not been entered.")
        error = error.replace("200文字以上のメールアドレスは登録できません。", "You can’t register email address more than 200 characters.")
        error = error.replace("電話番号が未入力です。", "Phone number has not been entered.")
        error = error.replace("電話番号は11文字以内で入力してください。", "Please enter phone number within 11 characters.")
        error = error.replace("電話番号を半角数字ハイフン無しで入力してください。", "Please enter the phone number without hyphens.")
        error = error.replace("生年月日が未入力です。", "The date of birth has not been entered.")
        error = error.replace("郵便番号が未入力です。", "The postal code has not been entered.")
        error = error.replace("郵便番号を半角数字ハイフン無しで入力してください。", "Please enter postal code without hyphens.")
        error = error.replace("郵便番号は7文字で入力してください。", "Please enter the postal code within 7 characters.")
        error = error.replace("住所を自動入力してください。", "Please enter the street address automatically.")
        error = error.replace("住所を200文字以下で入力してください。", "Please enter street address within 200 characters.")
        error = error.replace("住所2が未入力です。", "Street address 2 has not been entered.")
        error = error.replace("住所2には半角数字を含めて入力してください。", "Please enter half-width numbers in street address2.")
        error = error.replace("住所2を200文字以下で入力してください。", "Please enter  street address2 within 200 characters.")
        error = error.replace("パスワードは半角英字と半角数字それぞれ1文字以上含む8文字以上100文字以下で入力してください。", "Please enter password from 8 to 100 characters, including 1 or more letters and numbers.")
        return error;
    }

    public comma(value: number): string {
        return new Intl.NumberFormat('ja-JP', { style: 'decimal' }).format(value);
    }

    public toStringRank(rank: number) {
        switch (rank) {
            case 1:
                return "A";
            case 2:
                return "B";
            case 3:
                return "C";
            case 4:
                return "D";
            case 5:
                return "E";
            case 6:
                return "F";
            case 7:
                return "G";
            case 8:
                return "H";
            case 9:
                return "I";
            case 10:
                return "J";
            default:
                return "";
        }
    }

}
